import * as authentification from '@oel/js-authentification';

import { Logger } from '../utils';
import { getFakeJWT } from './cookieParser';
import { useFakeToken } from '../config';

export const getAuthorisationValeurHeader = async (): Promise<string> => {
    let bearer: any = '';

    if (useFakeToken()) {
        bearer = getFakeJWT();
    } else {
        bearer = await authentification
            .getAuthorization()
            .then((jwtToken) => {
                return jwtToken;
            })
            .catch((_err) => {
                Logger.error('error js-auth : ' + _err);
                return '';
            });
    }

    return Promise.resolve(bearer);
};
